import { Box, Tab, Tabs } from '@mui/material'
import { SyntheticEvent, useState } from 'react'

export interface ITabOptions {
  title: string
  size: number
  handleClick: () => void
}

interface ITableTabs {
  options: ITabOptions[]
}

const TableTabs = ({ options }: ITableTabs) => {
  const [currentValue, setCurrentValue] = useState<number>(0)

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setCurrentValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: '#E4E4E4' }}>
        <Tabs
          value={currentValue}
          onChange={handleChange}
        >
          {options.map(({ handleClick, title, size }, index) => (
            <Tab
              sx={{ fontFamily: 'Sora !important', fontWeight: '600 !important' }}
              key={index}
              label={size && size != 0 ? `${title} (${size})` : title}
              id={`simple-tab-${index}`}
              aria-controls={`simple-tabpanel-${index}`}
              onClick={handleClick}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  )
}

export default TableTabs
